import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import {
  RadioGroup as CoreRadioGroup,
  type RadioGroupProps as CoreRadioGroupProps,
} from "@b2bportal/core-ui";
import clsx from "clsx";
import styles from "./RadioGroup.module.scss";

export interface RadioGroupProps extends CoreRadioGroupProps {
  density?: "default" | "compact" | "comfortable";
}

export const RadioGroup = ({
  density = "default",
  className,
  ...props
}: RadioGroupProps) => {
  const [, cn] = useModuleBEM(styles, CoreUiComponents.RadioGroup);
  return <CoreRadioGroup {...props} className={clsx(className, cn(density))} />;
};
